import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { outreachAction } from '@/lib/outreach';
import { handOverImportText } from '@/lib/table-import-handoff';
import type { DashboardChatImportProposalResult } from '@shared/types/dashboard-chat';

/**
 * 03/11: the chat proposes to import the table the person gave into a
 * prospecting app (a new one when none fits). Nothing is written here: the
 * app opens with its import drawer filled, where the columns are checked.
 */
export const AppChatImportCard = ({ result }: { result: DashboardChatImportProposalResult }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const open = async () => {
    setBusy(true);
    setError(null);
    try {
      const key = result.appKey ?? (await outreachAction<{ key: string }>({ action: 'create_prospecting_app', title: 'Prospection' })).key;
      handOverImportText(key, result.sourceText);
      navigate(`/apps/${encodeURIComponent(key)}?import=1`);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'L’import n’a pas pu s’ouvrir.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-2 space-y-2 rounded-xl border border-domino-cardBorder bg-domino-white p-3">
      <p className="text-sm font-semibold text-domino-ink">{result.appTitle ?? 'Nouvelle prospection'}</p>
      <p className="text-xs text-domino-inkSoft">{result.rows} ligne{result.rows > 1 ? 's' : ''}</p>
      <Button size="sm" loading={busy} disabled={busy} onClick={() => { void open(); }}>Importer le tableau</Button>
      {error && <p role="alert" className="text-xs text-domino-inkSoft">{error}</p>}
    </div>
  );
};
